import * as React from "react";
import type { SVGProps } from "react";
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m14.672 8.001-1.335 1.334L12.003 8"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.228 4.23a5.335 5.335 0 0 1 9.11 3.772c0 .405-.05.798-.135 1.177M1.328 7.999l1.335-1.334L3.997 8"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.773 11.77a5.335 5.335 0 0 1-9.11-3.772c0-.405.048-.798.134-1.177"
    />
  </svg>
);
export default SvgRefresh;
